import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'; 
import App from './App';
import reportWebVitals from './reportWebVitals';

// BaiJamjuree fonts
import './fonts/BaiJamjuree-Bold.woff';
import './fonts/BaiJamjuree-Bold.woff2';
import './fonts/BaiJamjuree-BoldItalic.woff';
import './fonts/BaiJamjuree-BoldItalic.woff2';
import './fonts/BaiJamjuree-ExtraLight.woff';
import './fonts/BaiJamjuree-ExtraLight.woff2';
import './fonts/BaiJamjuree-ExtraLightItalic.woff';
import './fonts/BaiJamjuree-ExtraLightItalic.woff2';
import './fonts/BaiJamjuree-Italic.woff';
import './fonts/BaiJamjuree-Italic.woff2';
import './fonts/BaiJamjuree-Light.woff';
import './fonts/BaiJamjuree-Light.woff2';
import './fonts/BaiJamjuree-LightItalic.woff';
import './fonts/BaiJamjuree-LightItalic.woff2';
import './fonts/BaiJamjuree-Medium.woff';
import './fonts/BaiJamjuree-Medium.woff2';
import './fonts/BaiJamjuree-MediumItalic.woff';
import './fonts/BaiJamjuree-MediumItalic.woff2';
import './fonts/BaiJamjuree-Regular.woff';
import './fonts/BaiJamjuree-Regular.woff2';
import './fonts/BaiJamjuree-SemiBold.woff';
import './fonts/BaiJamjuree-SemiBold.woff2';
import './fonts/BaiJamjuree-SemiBoldItalic.woff';
import './fonts/BaiJamjuree-SemiBoldItalic.woff2';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log));
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
